import React, { useState, useEffect } from 'react';
import { useTheme } from '@mui/material/styles';
import Marquee from 'react-fast-marquee';
import SERVER_API_URL from '../../config';

function CrossSpinner() {
    const [activeIndex, setActiveIndex] = useState(0);
    const [isServerWorking, setIsServerWorking] = useState(true);
    const theme = useTheme();

    useEffect(() => {
        const internetConnectivity = async () => {
            try {
                await fetch(`${SERVER_API_URL}`);
                setIsServerWorking(true);
            } catch (error) {
                setIsServerWorking(false);
            }
        }
        internetConnectivity();
        const interval = setInterval(() => {
            setActiveIndex(prevIndex => (prevIndex + 1) % 3);
        }, 500);

        return () => clearInterval(interval);
    }, []);

    return (
        <div className="loading-container">
            <div className="logo-container">
                <img src="/assets/logo/eotc-logo.png" alt="Logo" className="logo" />
            </div>
            <div className="dots-container">
                <div className={`dot green ${activeIndex === 0 ? 'enlarge' : 'disabled'}`} />
                <div className={`dot yellow ${activeIndex === 1 ? 'enlarge' : 'disabled'}`} />
                <div className={`dot red ${activeIndex === 2 ? 'enlarge' : 'disabled'}`} />
            </div>

            {!isServerWorking && (
                <div className="temp-message">
                    <Marquee gradient gradientColor={theme.palette.mode === 'dark' ? '#34383a' : '#f0f0f0'} pauseOnHover>{" "}ይቅርታ፤ሰርቨራችን፣ለጊዜው፣አገልግሎት፣እየሰጠ፣አይደለም።{" "}</Marquee>
                </div>
            )}

        </div>
    );
}

export default CrossSpinner;
